<style>
.input-readonly > div > .vs-inputx {
  background-color: #e6e6e6;
}

.bg-highlight > td {
  background-color: #f80808;
  color: #e6e6e6;
}
</style>
<template>
  <div class="vx-col w-5/6 ml-auto mr-auto">
    <span>
      <h4 class="mb-5">Supplier Invoice</h4>
    </span>
    
    <div class="vx-row mb-2">
      <div class="vx-col w-1/2">
        <label class="vs-input--label">Transaction Date</label>
        <datepicker
          class="w-full"
          v-validate="'required'"
          :inline="false"
          name="Transaction Date"
          v-model="transaction_date"
          placeholder="Transaction date"
          format="MMMM dd, yyyy"
          label="Transaction Date"
          :disabledDates="disabledAfterToday"
        ></datepicker>
        <span
        class="text-danger text-sm"
        v-if="transaction_date == null && status_submit"
        >This field is required</span
      >
      </div>
    </div>
    <div class="vx-row mt-6">
      <div class="vx-col w-full">
        <vs-button class="mr-3 mb-2" @click="validate">Validate</vs-button>
      </div>
    </div>
    <vs-divider style="width: 100%; margin-left: 0%">Supplier Data</vs-divider>
    <div class="vx-row mb-2">
      <div class="vx-col w-1/3">
        <vs-input
          class="w-full input-readonly"
          label="Supplier"
          name="Supplier"
          v-model="vendor"
          readonly
        />
      </div>
      <div class="vx-col w-1/3">
        <vs-input
          class="w-full input-readonly"
          label="Supplier PIC"
          name="Supplier PIC"
          v-model="supplier_contact_name"
          readonly
        />
      </div>
      <div class="vx-col w-1/3">
        <vs-input
          class="w-full input-readonly"
          label="PIC Phone Number"
          name="PIC Phone Number"
          v-model="supplier_phone"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2" style="z-index: 99999 !important">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Bank Name"
          name="Supplier Bank Name"
          v-model="table.bank_name"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Tax Number"
          name="Supplier Tax Number"
          v-model="tr_number"
          placeholder="Supplier Tax Number"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Supplier Tax Date"
          name="Supplier Tax Date"
          v-model="tr_date"
          placeholder="Supplier Tax Date"
          readonly
        />
      </div>
    </div>
    <vs-divider style="width: 100%; margin-left: 0%">PO / GR Data</vs-divider>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Warehouse"
          name="Warehouse"
          v-model="warehouseName"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="PO Code"
          name="PO Code"
          v-model="poCode"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="PO Date"
          name="PO Date"
          v-model="po_date"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="GR Code"
          name="GR Code"
          v-model="gr_codes"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Proof of GR Date"
          name="Proof of GR Date"
          v-model="gr_dates"
          readonly
        />
      </div>
    </div>
    <vs-divider style="width: 100%; margin-left: 0%">Invoice Data</vs-divider>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          v-validate="'required'"
          class="w-full input-readonly"
          label="Invoice Number"
          name="Invoice Number"
          v-model="table.inv_code"
          placeholder="Invoice Number"
          readonly
        />
      </div>
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Invoice Date"
          name="Invoice Date"
          v-model="table.inv_date"
          readonly
        />
      </div>
    </div>
    <div v-if="createdDate != 'January 1, 0001'" class="vx-col w-full mb-2">
      <vs-input
        class="w-full input-readonly"
        label="Created Date"
        name="Created Date"
        v-model="createdDate"
        readonly
      />
    </div>
    <div class="vx-row mb-2" style="z-index: 99999 !important">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Payment Term"
          name="Payment Term"
          v-model="table.payment_term_name"
          readonly
        />
      </div>
    </div>
    <div v-if="dueDate != 'January 1, 0001'" class="vx-col w-full mb-2">
      <vs-input
        class="w-full input-readonly"
        label="Due Date"
        name="Due Date"
        v-model="dueDate"
        readonly
      />
    </div>
    <div class="vx-row mb-2">
      <div class="vx-col w-full">
        <vs-input
          class="w-full input-readonly"
          label="Currency Code"
          name="Currency Code"
          v-model="table.currency_code"
          readonly
        />
      </div>
    </div>
    <!-- <div class="vx-row mb-2 ml-1">
      <h5>Line Item</h5>
    </div> -->
    <!-- <div v-if="this.invType == 0">
      <vs-divider style="width: 100%; margin-left: 0%"><h5>Line Item</h5></vs-divider>
      <vs-table stripe border description :sst="true" :data="table.data">
        <template slot="thead">
          <vs-th>Item</vs-th>
          <vs-th v-if="project">Progress</vs-th>
          <vs-th v-else>Quantity</vs-th>
          <vs-th>Price</vs-th>
          <vs-th>Discount</vs-th>
          <vs-th>Net</vs-th>
          <vs-th>Delta</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr
            :data="tr"
            :key="indextr"
            v-for="(tr, indextr) in data"
            :class="data[indextr].class"
          >
            <vs-td :data="data[indextr].item_name">
              <div class="vx-row ml-0">
                <span class="w-5/5">{{ data[indextr].item_name }}</span>
              </div>
              <div class="vx-row ml-0">
                <span v-if="!project" class="w-5/5">{{ data[indextr].item_unit }}</span>
              </div>
            </vs-td>
            <vs-td v-if="project">
              PO : {{ data[indextr].progress_po }} %<br />
              GR : {{ data[indextr].progress_bast }} %<br />
            </vs-td>
            <vs-td v-else>
              PO : {{ data[indextr].qty_po }} {{ data[indextr].item_unit }}<br />
              Received : {{ data[indextr].qty_received }} {{ data[indextr].item_unit }}<br />
              Invoice : {{ data[indextr].quantity }} {{ data[indextr].item_unit }}
            </vs-td>
            <vs-td>
              <div v-if="project" class="vx-row ml-0">
                PO : {{ data[indextr].price_po_progress }}<br />
                GR : {{ data[indextr].price_bast_progress }}<br />
                Invoice : {{ data[indextr].price }}
              </div>
              <div v-else class="vx-row ml-0">
                PO : {{ data[indextr].price_po }}<br />
                Received : {{ data[indextr].price_po }}<br />
                Invoice : {{ data[indextr].price }}
              </div>
            </vs-td>
            <vs-td>
              <div v-if="project" class="vx-row ml-0">
                PO : {{ data[indextr].discount_po }}<br />
                GR : {{ data[indextr].discount_po }}<br />
                Invoice : {{ data[indextr].discount_inv }}
              </div>
              <div v-else class="vx-row ml-0">
                PO : {{ data[indextr].discount_po }}<br />
                Received : {{ data[indextr].discount_po }}<br />
                Invoice : {{ data[indextr].discount_inv }}
              </div>
            </vs-td>
            <vs-td>
              <div v-if="project" class="vx-row ml-0">
                PO : {{ data[indextr].net_po_progress }}<br />
                GR : {{ data[indextr].net_bast_progress }}<br />
                Invoice : {{ data[indextr].net_inv }}
              </div>
              <div v-else class="vx-row ml-0">
                PO : {{ data[indextr].net_po }}<br />
                Received : {{ data[indextr].net_received }}<br />
                Invoice : {{ data[indextr].net_inv }}
              </div>
            </vs-td>
            <vs-td>
              <div v-if="project" class="vx-row ml-0">
                Progress : {{ data[indextr].delta_progress }} %<br />
                Price : {{ data[indextr].delta_price_progress }}<br />
                Discount : {{ data[indextr].delta_discount }}<br />
                Net : {{ data[indextr].delta_net_progress }}
              </div>
              <div v-else class="vx-row ml-0">
                Qty : {{ data[indextr].delta_qty }}<br />
                Price : {{ data[indextr].delta_price }}<br />
                Discount : {{ data[indextr].delta_discount }}<br />
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>

    </div> -->
    <div v-if="!project" class="vx-row mb-2 mt-5 ml-1">
      <div class="vx-row ml-0">
        Total Item PO : {{number_format_qty(total_item_po)}}<br />
        Total Item Received : {{number_format_qty(total_item_received)}}<br />
        Total Item Invoice : {{number_format_qty(total_item_invoice)}}
      </div>
    </div>

    <!-- <div class="vx-row mb-2 mt-5 ml-1">
      <h5>Charges</h5>
    </div>
    <vs-table stripe border description :sst="true" :data="table.data_charges">
      <template slot="thead">
        <vs-th>Charge Name</vs-th>
        <vs-th>Value</vs-th>
        <vs-th>Tax</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{
                data[indextr].charge_name.replace(/-/g, " ")
              }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].value }}</span>
            </div>
          </vs-td>
          <vs-td>
            <div class="vx-row ml-0">
              <span class="w-5/5">{{ data[indextr].tax }}</span>
            </div>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table> -->

    <!-- PO -->
    <vs-divider style="width: 100%; margin-left: 0%"><h5>Summary</h5></vs-divider>
    <div class="vx-row w-5/5 mb-3 mt-6"> 
      <vs-input
        class="w-1/5 input-readonly"
        label="Item Value PO"
        name="Item Value PO"
        v-model="table.item_value_po"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pl-1 pr-1"
        label="Charges Value PO"
        name="Charges Value PO"
        v-model="table.charges_value_po"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pr-1"
        label="Tax Value PO"
        name="Tax Value PO"
        v-model="table.tax_value_po"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="Total Invoice Value PO"
        name="Total Invoice Value PO"
        v-model="table.total_po_value"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="WH Tax Value PO"
        name="WH Tax Value PO"
        v-model="table.wh_tax_value_po"
        readonly
      />
    </div>

    <!-- po - gr -->
    <div class="vx-row w-5/5 mb-3 mt-6">
      <vs-input
        class="w-1/5 input-readonly"
        label="Item Value PO-GR"
        name="Item Value PO-GR"
        v-model="table.item_value_po_gr"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pl-1 pr-1"
        label="Charges Value PO-GR"
        name="Charges Value PO-GR"
        v-model="table.charges_value_po_gr"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pr-1"
        label="Tax Value PO-GR"
        name="Tax Value PO-GR"
        v-model="table.tax_value_po_gr"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="Total Invoice Value PO-GR"
        name="Total Invoice Value PO-GR"
        v-model="table.total_po_gr_value"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="WH Tax Value PO-GR"
        name="WH Tax Value PO-GR"
        v-model="table.wh_tax_value_received"
        readonly
      />
    </div>

    <!-- received -->
    <div class="vx-row w-5/5 mb-3 mt-6" :style="table.is_skb == 1 ? 'margin-bottom: -3rem !important;' : ''">
      <vs-input
        class="w-1/5 input-readonly"
        label="Item Value Received"
        name="Item Value Received"
        v-model="table.item_value_received"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pl-1 pr-1"
        label="Charges Value Received"
        name="Charges Value Received"
        v-model="table.charges_value_received"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pr-1"
        label="Tax Value Received"
        name="Tax Value Received"
        v-model="table.tax_value_received"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="Total Invoice Value Received"
        name="Total Invoice Value Received"
        v-model="table.total_received_value"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="WH Tax Value Received"
        name="WH Tax Value Received"
        v-model="table.wh_tax_value_received"
        readonly
      />
      <div v-if="table.is_skb == 1" style="width: 10%; position: relative; top: -55px; left: 97%; text-align: center;">
        <p>SKB</p>
        <input type="checkbox" :checked="table.is_skb === 1" :disabled="table.is_skb === 1" v-model="table.is_skb" style="height: 80%;"/>
      </div>
    </div>
    <div class="vx-row w-5/5 mb-3 mt-6" :style="table.vat_expired == 1 ? 'margin-bottom: -4rem !important;' : ''">
      <vs-input
        class="w-1/5 input-readonly"
        label="Item Value"
        name="Item Value"
        v-model="table.item_value"
        readonly
      />

      <vs-input
        class="w-1/5 input-readonly pl-1 pr-1"
        label="Charges Value"
        name="Charges Value"
        v-model="table.charges_value"
        readonly
      />

      <vs-input
        class="w-1/5 input-readonly pr-1"
        label="Tax Value"
        name="Tax Value"
        v-model="table.tax_value"
        readonly
      />

      <vs-input
        class="w-1/5 input-readonly pr-1"
        label="Total Invoice Value"
        name="Total Invoice Value"
        v-model="table.total_inv_value"
        readonly
      />

      <vs-input
        class="w-1/5 input-readonly"
        label="WH Tax Value"
        name="WH Tax Value"
        v-model="table.wh_tax_value"
        readonly
      />
      <div v-if="table.vat_expired == 1" style="width: 10%; position: relative; top: -75px; left: 97%; text-align: center;">
        <p>VAT</p>
        <p>Expired</p>
        <input type="checkbox" :checked="table.vat_expired === 1" :disabled="table.vat_expired === 1" v-model="table.vat_expired" style="height: 80%;"/>
      </div>
    </div>
    <div class="vx-row w-5/5 mb-3 mt-6">
      <vs-input
        class="w-1/5 input-readonly"
        label="Item Value Faktur"
        name="Item Value Faktur"
        v-model="table.item_value_faktur"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pl-1 pr-1"
        label="Charges Value Faktur"
        name="Charges Value Faktur"
        v-model="table.charges_value_faktur"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly pr-1"
        label="Tax Value Faktur"
        name="Tax Value Faktur"
        v-model="table.tax_faktur"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="Total Invoice Value Faktur"
        name="Total Invoice Value Faktur"
        v-model="table.total_value_faktur"
        readonly
      />
      <vs-input
        class="w-1/5 input-readonly"
        label="WH Tax Value Faktur"
        name="WH Tax Value Faktur"
        v-model="table.wh_tax_value_faktur"
        readonly
      />
    </div>

    <vs-divider style="width: 100%; margin-left: 0%"></vs-divider>
    <div class="vx-row mb-6">
        <div class="vx-col w-full mb-6">
            <table width="100%" class="vs-table vs-table--tbody-table mb-6">
                <thead class="vs-table--thead">
                    <tr>
                        <th width="5%">Chart Of Account</th>
                        <th width="5%">Cost Center</th>
                        <th width="5%">Amount</th>
                        <th width="5%">Description</th>
                    </tr>
                </thead>
                <tbody>
                  <tr v-for="(invoiceCoa, index) in invoiceCoas" :key="index" style="padding-bottom: 5px">
                    <td class="td vs-table--td" style="padding: 5px">
                      <vs-input
                        class="input-readonly"
                        label=""
                        v-model="invoiceCoa.coa"
                        style="width:100%"
                        readonly
                      />
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                      <vs-input
                        class="input-readonly"
                        label=""
                        v-model="invoiceCoa.cc"
                        style="width:100%"
                        readonly
                      />
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                      <vs-input
                        class="input-readonly"
                        label=""
                        v-model="invoiceCoa.amount"
                        style="width:100%"
                        readonly
                      />
                    </td>
                    <td class="td vs-table--td" style="padding: 5px">
                      <vs-input
                        class="input-readonly"
                        label=""
                        v-model="invoiceCoa.description"
                        style="width:100%"
                        readonly
                      />
                    </td>
                  </tr>
                </tbody>
            </table>
        </div>
    </div>
    <vs-divider style="width: 100%; margin-left: 0%"><b>Notes</b></vs-divider>
    <template v-for="note in notes">
      <b v-bind:key="note">{{note}}
        <br>
      </b>
    </template>
    <vs-divider style="width: 100%; margin-left: 0%"
      >List Attachment</vs-divider
    >
    <div class="vx-row mb-3 mt-6 w-4/4" style="width: 100%; margin-left: 0%">
      <table class="vs-table vs-table--tbody-table">
        <template v-for="(tr, i) in table.file">
          <tr
            class="tr-values vs-table--tr tr-table-state-null selected"
            v-bind:key="tr.name"
          >
            <td class="td vs-table--td">{{ tr.doc_type }}</td>
            <td class="td vs-table--td">{{ tr.name }}</td>
            <td class="td vs-table--td">
              <vx-tooltip text="Show" v-if="tr.path != ''">
                <vs-button
                  type="line"
                  icon-pack="feather"
                  @click.stop="previewAttachment(tr.path)"
                  icon="icon-eye"
                />
              </vx-tooltip>
            </td>
            <td class="td vs-table--td">
              <vx-tooltip text="Download" v-if="tr.path != ''">
                <vs-button
                  type="line"
                  icon-pack="feather"
                  @click.stop="downloadFileAwsS3(tr.path)"
                  icon="icon-download"
                />
              </vx-tooltip>
            </td>
            <td class="td vs-table--td">
              <template>
                <vx-tooltip text="Delete">
                  <vs-button
                    type="line"
                    icon-pack="feather"
                    @click.stop="handleDeleteAttachment(i,tr.id)"
                    icon="icon-trash"
                  />
                </vx-tooltip>
              </template>
            </td>
          </tr>
        </template>
      </table>
    </div>

    <vs-popup title="Preview" :active.sync="showAttachment" :fullscreen="true">
      <iframe
        v-if="showAttachment"
        :src="attachmentPath"
        style="width: 100%; height: 80dvh"
      />
    </vs-popup>
  </div>
</template>
<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  props: {
    piId: {
      type: Number,
    },
    vendor: {
      type: String,
    },
    poCode: {
      type: String,
    },
    invCode: {
      type: String,
    },
    warehouseCode: {
      type: String,
    },
    warehouseName: {
      type: String,
    },
    createdDate: {
      type: String,
    },
    dueDate: {
      type: String,
    },
    project:{
      type: Boolean,
    }
  },
  created() {},
  data() {
    return this.initialState();
  },
  methods: {
    initialState() {
      return {
        showAttachment: false,
        attachmentPath: "",
        optionPaymentTerm: [],
        optionBankName: [],
        search: "",
        offset: 0,
        limit: 10,
        status_submit: false,
        table: {
          inv_code: null,
          inv_date: null,
          payment_term: null,
          bank_name: null,
          account_name: null,
          account_number: null,
          total_inv_value: 0,
          total_value_faktur: 0,
          item_value: 0,
          item_value_faktur: 0,
          charges_value: 0,
          charges_value_faktur: 0,
          discount_value_faktur: 0,
          tax_value: 0,
          tax_faktur: 0,
          wh_tax_value_faktur: 0,
          wh_tax_value_po: 0,
          wh_tax_value_received: 0,
          data: [],
          data_charges: [],
          file: [],
          is_skb: 0,
          vat_expired: 0,
        },
        tax_item: [],
        net: [],
        total: [],
        taxx: [0, 0],
        notes: "",
        gr_codes: "",
        transaction_date: new Date(),
        disabledAfterToday: {
          from: new Date(), // Disable all dates after specific date
        },
        invoiceCoas: [{coa: "", cc: "", amount:""}],
        invType: 0,
        supplier_contact_name: "",
        supplier_phone: "",
        tr_number: "",
        tr_date: "",
        po_date: "",
        gr_dates: "",
        total_item_po: 0,
        total_item_received: 0,
        total_item_invoice: 0,
      };
    },
    validate() {
      this.status_submit = true;
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$vs.loading();
          let param = {
            pi_id: this.piId,
            transaction_date: moment(this.transaction_date).add(7, 'h'),
          };
          this.$http
            .post("/api/v1/pi/validate-invoice-nt", param)
            .then((resp) => {
              if (resp.code == 200) {
                this.handleClose();
                this.$vs.notify({
                  color: "success",
                  title: "Success",
                  text: resp.message,
                  position: "top-right",
                  iconPack: "feather",
                  icon: "icon-x-circle",
                });
              } else {
                this.$vs.notify({
                  color: "danger",
                  title: "Error",
                  text: resp.message,
                  position: "top-right",
                  iconPack: "feather",
                  icon: "icon-x-circle",
                });
              }
              this.$vs.loading.close();
            })
            .catch((error) => {
              this.$vs.loading.close();
              console.log(error);
            });
        }
      });
    },
    handleClose() {
      window.scrollTo(0, 0);
      this.$emit("close");
    },
    number_format(text){
      return text.toFixed(2).toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    number_format_qty(text){
      return text.toString().replace(/,/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    handleShowAttachment(selected) {
      if (selected.path != "") {
        this.downloadFileAwsS3(selected.path);
      }
    },
    handleDeleteAttachment(index,id) {
      this.table.file = this.table.file.filter((item, i) => i != index);
      this.deleteFile(id);
    },
    deleteFile(id) {
      this.$vs.loading()
      var form = new FormData()
      form.append('id',id)
      this.$http
        .post("/api/v1/pi/delete-file", form, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((resp) => {
          this.$vs.loading.close();
          if (resp.code == 200) {
            this.$vs.notify({
              color: "success",
              title: "Success",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    getData() {
      this.$vs.loading();
      this.$http
        .get("/api/v1/pi/vendor-invoice-line/" + this.piId)
        .then((resp) => {
          this.$vs.loading.close();
          this.invType = resp.data.inv_type
          this.table.is_skb = resp.data.is_skb;
          this.table.vat_expired = resp.data.vat_expired;
          console.log("SKB",resp.data.is_skb)
          if (resp.code == 200) {
            if(resp.data.inv_type == 1){
              this.createdDate = moment(String(new Date(resp.data.released_date))).format("YYYY-MM-DD");
            }
            this.dueDate = moment(String(new Date(resp.data.due_date))).format("YYYY-MM-DD");
            this.supplier_contact_name = resp.data.supplier_contact_name;
            this.supplier_phone = resp.data.supplier_phone;
            this.tr_date = moment(String(resp.data.tr_date)).format("YYYY-MM-DD") == "0001-01-01" ? "" : moment(String(new Date(resp.data.tr_date))).format("YYYY-MM-DD");
            this.tr_number = resp.data.tr_number;
            this.table.currency_code = resp.data.currency_code;
            this.table.inv_date =
              this.invCode != 0
                ? moment(String(new Date(resp.data.inv_date))).format("YYYY-MM-DD")
                : null;
            this.po_date = resp.data.po_date
            // this.po_date = moment(String(resp.data.po_date)).format("YYYY-MM-DD");
            this.gr_dates = resp.data.gr_dates;
            this.table.bank_name = resp.data.bank_name + " - " + resp.data.account_number + " " + resp.data.account_name;
            this.gr_codes = resp.data.gr_codes;
            this.notes = resp.data.supplier_invoice_notes.toString().split(";")
            this.table.payment_term_name = resp.data.payment_term_name;
            this.table.item_value = this.number_format(resp.data.item_value)
            this.table.charges_value = this.number_format(resp.data.charge_value)
            this.table.tax_value = this.number_format(resp.data.tax_value)
            this.table.discount_value = this.number_format(resp.data.total_discount)
            this.table.total_inv_value = this.number_format(resp.data.total_invoice_value)

            this.table.item_value_po = this.number_format(Math.round(resp.data.item_value_po-resp.data.discount_value_po))
            this.table.charges_value_po = this.number_format(Math.round(resp.data.charge_value_po))
            this.table.tax_value_po = this.number_format(Math.round(resp.data.tax_value_po))
            this.table.discount_value_po = this.number_format(Math.round(resp.data.discount_value_po))
            this.table.total_po_value = this.number_format(Math.round(resp.data.total_po_value))

            this.table.item_value_received = this.number_format(Math.round(resp.data.item_value_received-resp.data.discount_value_received))
            this.table.charges_value_received = this.number_format(Math.round(resp.data.charge_value_received))
            this.table.tax_value_received = this.number_format(Math.round(resp.data.tax_value_received))
            this.table.discount_value_received = this.number_format(Math.round(resp.data.discount_value_received))
            this.table.total_received_value = this.number_format(Math.round(resp.data.total_received_value))

            this.table.item_value_po_gr = this.number_format(Math.round(resp.data.item_value_received-resp.data.discount_value_received))
            this.table.charges_value_po_gr = this.number_format(Math.round(resp.data.charge_value_received))
            this.table.tax_value_po_gr = this.number_format(Math.round(resp.data.tax_value_received))
            this.table.total_po_gr_value = this.number_format(Math.round(resp.data.total_received_value))

            this.table.item_value_faktur = this.number_format(resp.data.item_value_faktur)
            this.table.charges_value_faktur = this.number_format(0)
            this.table.tax_faktur = this.number_format(resp.data.tax_faktur)
            this.table.discount_value_faktur = this.number_format(0)
            this.table.total_value_faktur = this.number_format(resp.data.total_value_faktur)  

            this.table.po_code = resp.data.po_code;
            this.table.vendor = resp.data.vendor;
            this.total_item_po = resp.data.total_item_po ? resp.data.total_item_po : 0;
            this.total_item_received = 0;
            this.total_item_invoice = 0;
            let wh_tax_val = 0;
            let _this = this;
            resp.data.data_line.forEach(function (element, index) {
              wh_tax_val += element.wh_tax
              // _this.total_item_po += parseFloat(element.qty_po);
              _this.total_item_received += parseFloat(element.qty_received);
              _this.total_item_invoice += parseFloat(element.quantity);

              let price_po_progress = element.price_po
              let price_bast_progress = element.price_po
              let net_po_progress = element.net_po * (element.progress_po/100)
              let net_bast_progress = element.net_po * (element.progress_bast/100)

              let asd = '';
              if(_this.project) {
                if(Math.abs(net_po_progress - net_bast_progress).toFixed(2) > 0 || Math.abs(price_bast_progress - price_po_progress) > 0 || Math.abs(element.progress_po - element.progress_bast).toFixed(2) > 0 || Math.abs(element.discount - element.discount_inv).toFixed(2) > 0){
                  asd = 'bg-highlight'
                }
              } else {
                if(Math.abs(element.quantity - element.qty_received) > 0 || Math.abs(element.price_po - element.price).toFixed(2) > 0 || Math.abs(element.discount - element.discount_inv).toFixed(2) > 0){
                  asd = 'bg-highlight'
                }
              }
              
              _this.table.data.push({
                progress_po: element.progress_po,
                progress_bast: element.progress_bast,
                class: asd,
                net: _this.number_format(parseFloat(element.net)),
                price: _this.number_format(element.price),
                price_po: _this.number_format(element.price_po),
                price_po_progress: _this.number_format(price_po_progress),
                price_bast_progress: _this.number_format(price_bast_progress),
                tax: _this.number_format(parseFloat(element.tax)),
                quantity: _this.number_format_qty(element.quantity),
                item_name: element.item_name,
                item_unit: element.item_unit,
                id: element.id,
                amount_uom: element.amount_uom,
                qty_received: _this.number_format_qty(element.qty_received),
                qty_po: _this.number_format_qty(element.qty_po),
                tax_rate: element.tax_rate,

                discount_po: _this.number_format(element.discount),
                discount_inv: _this.number_format(element.discount_inv),
                net_po: _this.number_format(element.net_po),
                net_po_progress: _this.number_format(net_po_progress),
                net_received: _this.number_format(element.net_received),
                net_bast_progress: _this.number_format(net_bast_progress),
                net_inv: _this.number_format(element.net_inv),
                delta_net: _this.number_format(Math.abs(element.net_inv - element.net_po)),
                delta_net_progress: _this.number_format(Math.abs(net_po_progress - net_bast_progress)),
                delta_progress: _this.number_format(Math.abs(element.progress_po - element.progress_bast)),
                delta_qty: _this.number_format(Math.abs(element.quantity - element.qty_received)),
                delta_price: _this.number_format(Math.abs(element.price_po - element.price)),
                delta_price_progress: _this.number_format(Math.abs(price_bast_progress - price_po_progress)),
                delta_discount: _this.number_format(Math.abs(element.discount - element.discount_inv))
              });
            });

            this.table.wh_tax_value = wh_tax_val
              .toFixed(2)
              .toString()
              .replace(/,/g, "")
              .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
              
            resp.data.data_charge.forEach(function (element, index) {
              _this.table.data_charges.push({
                value: _this.number_format(element.value),
                tax: _this.number_format(element.tax),
                id: element.id,
                charge_name: element.charge_name,
                tax_rate: element.tax_rate,
              });
            });
          
            resp.data.data_attachment.map((r,i) => {
              _this.table.file.push({
                id: r.id,
                name: r.name,
                path: r.path,
                doc_type: r.doc_type,
              })
            })

            if(resp.data.data_coa.length > 0){
              _this.invoiceCoas = [];
              resp.data.data_coa.forEach(function (element, index) {
                _this.invoiceCoas.push({
                  coa: element.coa_code + " - " + element.coa_name,
                  cc: element.cc_code + " - " + element.cc_name,
                  amount: element.amount,
                  description: element.description,
                });
              });
            }
          } else {
            this.$vs.notify({
              color: "danger",
              title: "Error",
              text: resp.message,
              position: "top-right",
              iconPack: "feather",
              icon: "icon-x-circle",
            });
          }
        })
        .catch((error) => {
          this.$vs.loading.close();
          console.log(error);
        });
    },
    async previewAttachment(path) {
      const url = await this.previewFileAwsS3(path);
      if (url) {
        this.attachmentPath = url;
        this.showAttachment = true;
      }
    },
  },
  mounted() {
    if (this.piId) {
      this.getData();
      this.table.inv_code = this.invCode != 0 ? this.invCode : null;
    }
  },
  computed: {},
  watch: {
    piId() {
      Object.assign(this.$data, this.initialState());
      this.getData();
      this.table.inv_code = this.invCode != 0 ? this.invCode : null;
    },
  },
};
</script>
<style scoped>
.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}

.pagination button {
  flex-grow: 1;
}

.pagination button:hover {
  cursor: pointer;
}
</style>